import { scaleLinear, select } from "d3";
import { ChartTicks } from "../ChartTicks";

export class Slider {
  constructor(name) {
    this.name = name;
    this.svg = null;
    this.g = null;
    this.data = null;
  }

  // Scale
  setScale({ data = [], sliderName, heightSvg, widthSvg, axisValue }) {
    const parentElement = `${this.name}-div`;
    const childElement = `svg-${this.name}`;
    const sliderElement = document.querySelector(`.${sliderName}`);
    const sliderWidth = sliderElement.clientWidth;

    select(sliderElement)
      .append("div")
      .style("z-index", 1)
      .attr("id", parentElement);

    const svg = select(`#${parentElement}`)
      .append("svg")
      .attr("id", childElement)
      .attr("height", heightSvg)
      .attr("width", widthSvg);
    svg[axisValue] = scaleLinear()
      .domain([0, data.length - 1])
      .range([0, sliderWidth]);

    this.svg = svg;
    this.data = data;
  }
}

Object.assign(Slider.prototype, ChartTicks);
